module.exports = __webpack_public_path__ + "static/img/student_member_type.ba6ff91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student_member_type.png
// module id = UbCi
// module chunks = 2